import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
    state: () => ({
        is_mobile:false,
        mobile_ls:false,
        is_tablet:false,
        is_search_mobile:false,
        click_banner:false,
        nav_drawer:false,
        header_props:{
            sortByText: 'Ordenar Por'
        },
    }),

    actions: {
        setIsTablet(value) {
            this.is_tablet = value;
        },
        setIsMobile(value) {
            this.is_mobile = value;
        },
        setMobileLS(value) {
            this.mobile_ls = value;
        },
        setSearchMobile(value) {
            this.is_search_mobile = value;
        },
        setClickBanner(value) {
            this.click_banner = value;
        },
        setNavDrawer(value) {
            this.nav_drawer = value;
        },
    },
    getters: {
        isTablet: (state) => state.is_tablet ?? false,
        isMobile: (state) => state.is_mobile ?? false,
        mobileLS: (state) => state.mobile_ls ?? false,
        isSearchMobile: (state) => state.is_search_mobile ?? false,
        headerProps: (state) => state.header_props,
        clickBaner: (state) => state.click_banner ?? false,
        navDrawer: (state) => state.nav_drawer ?? false
    },
});
